import { v4 as uuidv4 } from 'uuid';
import { getTenantConfig } from '../tenantConfig';
import { ROUTE_CONFIG } from './constants';
import { getCookies, pushData, getState, setState } from './helpers';
import { appendGTMIframe, appendGTMSnippet } from './initialize';
const GTM_ENABLED = process.env.REACT_APP_GTM_ENABLED === 'true';
const GTM_ID = process.env.REACT_APP_GTM_ID;
const GTM_ID_2 = process.env.REACT_APP_GTM_ID_2;
const UIM_USER_ID_FIELD = process.env.REACT_APP_UIM_USER_ID_FIELD;

const pageView = (url) => {
  const urlKey = url.split('?')[0];
  const { pageID = '', pageTitle = '' } = ROUTE_CONFIG?.[urlKey] ?? {};
  setState({
    pageID,
    pageTitle,
    pageViewID: uuidv4(),
    virtPath: urlKey,
  });
  const pageView = {
    ...getState(),
    event: 'virtPath',
  };
  pushData(pageView);
};

const event = ({ action, label }) => {
  const event = {
    ...getState(),
    event: 'gaIntEvent',
    eventAction: action,
    eventCategory: 'Interactions',
    eventLabel: label,
  };
  pushData(event);
};

const trackQueryParams = (params = {}) => {
  const paramDefaults = {
    ...((params.application || params.client_id) && {
      campaignID: params.application || params.client_id,
    }),
    ...(params.country && { locale: params.country.toLowerCase() }),
    ...(params.language && { language: params.language.toLowerCase() }),
    ...(params.cd12 && { clientID: params.cd12 }),
    ...(params.cd124 && { devicePlatform: params.cd124 }),
    ...(params.cd56 && { mobileID: params.cd56 }),
  };

  return paramDefaults;
};

const appendGAScripts = () => {
  if (GTM_ID) {
    appendGTMSnippet(GTM_ID);
    appendGTMIframe(GTM_ID);
  }
  if (GTM_ID_2) {
    appendGTMSnippet(GTM_ID_2);
    appendGTMIframe(GTM_ID_2);
  }
};

// Initializes analytics setup, pulls relevant fields from query params and tenant config
// Meta info must be pushed to dataLayer before GTMs load, so moved GA scripts from
// public index.html to here for imperative insertion after meta is configured
// See: RBDMAI-1906, RBDMAI-1846
const init = (params) => {
  const { brand, propertyName } = getTenantConfig().analytics;
  const paramDefaults = trackQueryParams(params);
  const { language, locale } = paramDefaults;
  const meta = {
    brand,
    event: 'init-meta',
    environment: 'on-site',
    isSpa: 'true',
    language,
    locale,
    propertyName,
    siteType: 'website',
  };

  pushData(meta);
  setState({
    ...meta,
    ...paramDefaults,
    ...getCookies(),
  });

  if (GTM_ENABLED) appendGAScripts();
};

const trackUser = (user = {}) => {
  setState({
    userID: user?.[UIM_USER_ID_FIELD],
  });
};

export { event, init, pageView, trackQueryParams, trackUser };
